
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/auth/partnerships/checkout",
      function () {
        return require("private-next-pages/docs/auth/partnerships/checkout.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/auth/partnerships/checkout"])
      });
    }
  